import { ETrackingEventType } from '@constants';
import { ICreateTrackingEvent, ITrackingEventDataMapping } from '@sdk/contracts';
import { useCallback } from 'react';

import { useProfile } from '@/store';
import { useMutateTrackingEvents } from '@/store/tracking-events';
import { detectDevice } from '@/utils';

type ITrackingEventParams<T extends ETrackingEventType> = {
  eventType: T;
  eventData: ITrackingEventDataMapping[T];
};

export const useTrackingEvents = () => {
  const { profile } = useProfile();
  const { createTrackingEvent } = useMutateTrackingEvents();

  const trackEvent = useCallback(
    <T extends ETrackingEventType>({ eventType, eventData }: ITrackingEventParams<T>) => {
      try {
        if (!profile) {
          throw new Error('User profile required for tracking');
        }

        if (!eventData || typeof eventData !== 'object') {
          throw new Error(`Invalid eventData for ${eventType}`);
        }

        const trackingEvent: ICreateTrackingEvent = {
          eventType,
          user: profile._id,
          platformUrl: window.location.href,
          userDevice: detectDevice(),
          userAgent: navigator.userAgent,
          eventData
        };

        createTrackingEvent(trackingEvent);
      } catch (error) {
        console.error('Failed to track event:', error);
      }
    },
    [profile, createTrackingEvent]
  );

  return {
    trackEvent
  };
};
